import ActionTypes from '../../actionTypes';
import API from '../../../API';
/**
 * Action creator for the search criteria GET request
 */
var fetchSearchCriteriaGetRequest = function () { return ({
    type: ActionTypes.FETCH_SEARCH_CRITERIA_REQUEST,
}); };
/**
 * Action creator for the search criteria GET response
 */
var fetchSearchCriteriaGetResponse = function (data) { return ({
    type: ActionTypes.FETCH_SEARCH_CRITERIA_RESPONSE,
    payload: data,
}); };
/**
 * Action creator for the search criteria GET invalidate
 */
var fetchSearchCriteriaGetInvalidate = function (error) { return ({
    type: ActionTypes.FETCH_SEARCH_CRITERIA_INVALIDATE,
    error: error,
}); };
/**
 * Returns a function that fetches data from the search criteria API and performs
 * the subsequent dispatch operations to send the data or the error to the store.
 */
var fetchSearchCriteria = function () { return function (dispatch) {
    dispatch(fetchSearchCriteriaGetRequest());
    API.getAvailableSearchCriteria()
        .then(function (data) { return dispatch(fetchSearchCriteriaGetResponse(data)); })
        .catch(function (error) { return dispatch(fetchSearchCriteriaGetInvalidate(error.message)); });
}; };
export default fetchSearchCriteria;
